<template>
  <FormBox
    :title="$t('message.DataRegistration.formData.vehicle')"
    style="background: #fff"
  >
    <el-form
      ref="ruleForm"
      :model="form.vehicle"
      class="form_type1_box"
      :rules="vehicleRules"
      hide-required-asterisk
    >
      <!-- <el-row :gutter="86"> -->
      <!-- 車輛的註冊編號 -->
      <el-row :gutter="86">
        <el-col :xs="24" :sm="24">
          <el-form-item
            :label="$t('message.DataRegistration.Vehicle.registNoAndIdNo')"
            prop="regAndIdNo"
          >
            <el-input
              :placeholder="
                $t('message.DataRegistration.Vehicle.registNoAndIdNo_plh')
              "
              ref="registrationNo"
              v-model="form.vehicle.regAndIdNo"
              class="input-with-select"
              @focus="onRegistNoFocus"
              maxlength="8"
              :disabled="applicationType == 'RENEW'"
            ></el-input>
          </el-form-item>
          <div v-if="applicationType == 'FIRST'" class="tips_red">
            {{ $t("message.registrationNo_tips") }}
          </div>
        </el-col>
      </el-row>
      <!-- 分割线 -->
      <el-row :gutter="86">
        <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="24">
          <el-divider>{{ $t("message.hk_vehicle") }}</el-divider>
          <el-row :gutter="86"></el-row>
        </el-col>
      </el-row>
      <!-- 發出香港保險單的保險公司名稱 -->
      <el-row :gutter="86">
        <el-col :xs="24" :sm="12">
          <el-form-item
            v-if="applicationType == 'FIRST'"
            :label="$t('message.DataRegistration.Vehicle.hkInsuranceCompany')"
            prop="hkInsuranceCompany"
          >
            <el-input
              v-model="form.vehicle.hkInsuranceCompany"
              :placeholder="
                $t('message.DataRegistration.Vehicle.hkInsuranceCompany_plh')
              "
            ></el-input>
          </el-form-item>
        </el-col>
        <!-- 車輛的香港保險單編號 -->
        <el-col :xs="24" :sm="12">
          <el-form-item
            v-if="applicationType == 'FIRST'"
            :label="$t('message.DataRegistration.Vehicle.hkInsuranceNo')"
            prop="hkInsuranceNo"
          >
            <el-input
              v-model="form.vehicle.hkInsuranceNo"
              :placeholder="
                $t('message.DataRegistration.Vehicle.hkInsuranceNo_plh')
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 車輛的香港保險單生效日期 -->
      <el-row :gutter="86">
        <el-col :xs="24" :sm="12">
          <el-form-item
            v-if="applicationType == 'FIRST'"
            prop="hkInsuranceStartDate"
          >
            <slot name="label">
              <span class="el-form-item__label">
                {{
                  $t("message.DataRegistration.Vehicle.hkInsuranceStartDate")
                }}
                <el-tooltip
                  popper-class="m-tooltip-popper"
                  effect="dark"
                  :content="$t('message.insuranceStartDateTips')"
                  placement="top-start"
                  width="500px"
                >
                  <i class="el-icon-question pointer"></i>
                </el-tooltip>
              </span>
            </slot>
            <el-date-picker
              v-model="form.vehicle.hkInsuranceStartDate"
              type="date"
              :placeholder="
                $t('message.DataRegistration.Vehicle.hkInsuranceStartDate_plh')
              "
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              :picker-options="checkHKInsuranceStartDate"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <!-- 車輛的香港保險單結束日期 -->
        <el-col :xs="24" :sm="12">
          <el-form-item
            v-if="applicationType == 'FIRST'"
            :label="$t('message.DataRegistration.Vehicle.hkInsuranceEndDate')"
            prop="hkInsuranceEndDate"
          >
            <el-date-picker
              v-model="form.vehicle.hkInsuranceEndDate"
              type="date"
              :placeholder="
                $t('message.DataRegistration.Vehicle.hkInsuranceEndDate_plh')
              "
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              :picker-options="checkHKInsuranceEndDate"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 分割线 -->
      <el-row :gutter="86">
        <el-col v-if="applicationType == 'FIRST'" :xs="24" :sm="24">
          <el-divider>{{ $t("message.mainland_vehicle") }}</el-divider>
          <el-row :gutter="86"></el-row>
        </el-col>
      </el-row>
      <!-- 車輛於內地登記車牌編號 -->
      <el-row :gutter="86">
        <el-col :xs="24" :sm="12">
          <el-form-item
            :label="
              $t('message.DataRegistration.Vehicle.mainlandRegistrationNo')
            "
            prop="mainlandRegistrationNo"
          >
            <el-input
              v-model="form.vehicle.mainlandRegistrationNo"
              :placeholder="
                $t(
                  'message.DataRegistration.Vehicle.mainlandRegistrationNo_plh'
                )
              "
            >
              <template slot="prepend">粤</template>
            </el-input>
          </el-form-item>
        </el-col>
        <!-- 車輛的內地保險單編號 -->
        <el-col :xs="24" :sm="12">
          <el-form-item
            :label="$t('message.DataRegistration.Vehicle.mainlandInsuranceNo')"
            prop="mainlandInsuranceNo"
          >
            <el-input
              v-model="form.vehicle.mainlandInsuranceNo"
              :placeholder="
                $t('message.DataRegistration.Vehicle.mainlandInsuranceNo_plh')
              "
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="86">
        <!-- 車輛的內地保險單生效日期 -->
        <el-col :xs="24" :sm="12">
          <el-form-item prop="mainlandInsuranceStartDate">
            <slot name="label">
              <span class="el-form-item__label">
                {{
                  $t(
                    "message.DataRegistration.Vehicle.mainlandInsuranceStartDate"
                  )
                }}
                <el-tooltip
                  v-if="applicationType == 'FIRST'"
                  popper-class="m-tooltip-popper"
                  effect="dark"
                  :content="$t('message.insuranceStartDateTips')"
                  placement="top-start"
                  width="500px"
                >
                  <i class="el-icon-question pointer"></i>
                </el-tooltip>
              </span>
            </slot>
            <el-date-picker
              v-model="form.vehicle.mainlandInsuranceStartDate"
              type="date"
              :placeholder="
                $t(
                  'message.DataRegistration.Vehicle.mainlandInsuranceStartDate_plh'
                )
              "
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              :picker-options="checkMainlandInsuranceStartDate"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <!-- 車輛的內地保險單結束日期 -->
        <el-col :xs="24" :sm="12">
          <el-form-item
            :label="
              $t('message.DataRegistration.Vehicle.mainlandInsuranceEndDate')
            "
            prop="mainlandInsuranceEndDate"
          >
            <el-date-picker
              v-model="form.vehicle.mainlandInsuranceEndDate"
              type="date"
              :placeholder="
                $t(
                  'message.DataRegistration.Vehicle.mainlandInsuranceEndDate_plh'
                )
              "
              format="dd/MM/yyyy"
              value-format="yyyy-MM-dd"
              :picker-options="checkMainlandInsuranceEndDate"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- </el-row> -->
    </el-form>
    <!-- 註冊編號和車身編號彈窗 -->
    <RegistrationNoDialog
      v-if="showRegistrationNoDialog"
      @save="registNoSave"
      @close="showRegistrationNoDialog = false"
    ></RegistrationNoDialog>
  </FormBox>
</template>

<script>
import i18n from "../../../../../public/lang/index";
import FormBox from "./FormBox";
import RegistrationNoDialog from "../../../../components/RegistrationNoDialog";
export default {
  props: {
    form: {
      type: Object,
      default: () => {
        return {
          vehicle: {},
        };
      },
    },
    applicationType: String,
  },
  components: { FormBox, RegistrationNoDialog },
  data() {
    let hkInsuranceEndDateCheck = (rule, value, callback) => {
      let date2 = new Date();
      var date1 = value ? new Date(Date.parse(value.replace(/-/g, "/"))) : null;
      var iDays = date1
        ? parseInt(
            Math.abs(date2.getTime() - date1.getTime()) / 1000 / 60 / 60 / 24
          )
        : null;
      if (value && iDays < 270) {
        callback(
          new Error(i18n.t("message.formRuleMessage.hkInsuranceEndDateCheck"))
        );
      } else {
        callback();
      }
    };
    let mainlandInsuranceEndDateCheck = (rule, value, callback) => {
      const today = new Date();
      today.setHours(0, 0, 0, 0); // 確保比較的是日期部分，不包含時間
      const selectedDate = new Date(value);
      if (selectedDate < today) {
        callback(
          new Error(
            i18n.t("message.formRuleMessage.mainlandInsuranceEndDateCheck")
          )
        );
      } else {
        callback();
      }
    };
    return {
      beforeToday: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 8.64e6; //如果没有后面的-8.64e6就是不可以选择今天
        },
      },
      // 香港保險單生效日期範圍
      checkHKInsuranceStartDate: {
        disabledDate: (time) => {
          const hkInsuranceEndDate = this.form.vehicle.hkInsuranceEndDate;
          if (hkInsuranceEndDate) {
            return time.getTime() > new Date(hkInsuranceEndDate).getTime();
          }
        },
      },
      // 香港保險單結束日期範圍
      checkHKInsuranceEndDate: {
        disabledDate: (time) => {
          const hkInsuranceStartDate =
            this.form.vehicle.hkInsuranceStartDate || null;
          const date = new Date();
          let myDate =
            hkInsuranceStartDate && new Date(hkInsuranceStartDate) > date
              ? new Date(hkInsuranceStartDate)
              : date;
          return time.getTime() < myDate.getTime() - 1 * 24 * 60 * 60 * 1000;
        },
      },
      // 內地保險單生效日期範圍
      checkMainlandInsuranceStartDate: {
        disabledDate: (time) => {
          const mainlandInsuranceEndDate =
            this.form.vehicle.mainlandInsuranceEndDate;
          if (mainlandInsuranceEndDate) {
            return (
              time.getTime() > new Date(mainlandInsuranceEndDate).getTime()
            );
          }
        },
      },
      // 內地保險單結束日期範圍
      checkMainlandInsuranceEndDate: {
        disabledDate: (time) => {
          const mainlandInsuranceStartDate =
            this.form.vehicle.mainlandInsuranceStartDate || null;
          let myDate =
            mainlandInsuranceStartDate && new Date(mainlandInsuranceStartDate);
          return (
            myDate &&
            time.getTime() < myDate.getTime() - 1 * 24 * 60 * 60 * 1000
          );
        },
      },
      vehicleRules: {
        // registrationNo: [{ required: true, message: "不能為空" }],
        // identificationNo: [
        //   { required: true, message: "不能為空", trigger: "blur" },
        //   { max: 50, message: "長度在50個字符內", trigger: "blur" }
        // ],
        identificationNo: [
          {
            max: 30,
            message: i18n.t("message.formRuleMessage.maxLength30"),
            trigger: "blur",
          },
        ],
        hkInsuranceCompany: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 100,
            message: i18n.t("message.formRuleMessage.maxLength100"),
            trigger: "blur",
          },
        ],
        hkInsuranceNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 50,
            message: i18n.t("message.formRuleMessage.maxLength50"),
            trigger: "blur",
          },
        ],
        hkInsuranceStartDate: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.changeDate"),
            trigger: "change",
          },
        ],
        hkInsuranceEndDate: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.changeDate"),
            trigger: "change",
          },
          { validator: hkInsuranceEndDateCheck, trigger: "change" },
          { validator: hkInsuranceEndDateCheck, trigger: "blur" },
        ],
        mainlandInsuranceNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 50,
            message: i18n.t("message.formRuleMessage.maxLength50"),
            trigger: "blur",
          },
        ],
        mainlandInsuranceStartDate: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.changeDate"),
            trigger: "change",
          },
        ],
        mainlandInsuranceEndDate: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.changeDate"),
            trigger: "change",
          },
          { validator: mainlandInsuranceEndDateCheck, trigger: "change" },
          { validator: mainlandInsuranceEndDateCheck, trigger: "blur" },
        ],
        mainlandRegistrationNo: [
          {
            max: 20,
            message: i18n.t("message.formRuleMessage.maxLength20"),
            trigger: "blur",
          },
        ],
        regAndIdNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
          },
          {
            max: 8,
            message: i18n.t("message.formRuleMessage.maxLength8"),
            trigger: "blur",
          },
        ],
      },
      registrationNoType: "1",
      showRegistrationNoDialog: false,
      registNoForm: {},
      registNoRules: {
        registrationNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
          {
            max: 20,
            message: i18n.t("message.formRuleMessage.maxLength20"),
            trigger: "blur",
          },
        ],
        identificationNo: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
        ],
        captcha: [
          {
            required: true,
            message: i18n.t("message.formRuleMessage.notNull"),
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    // 子組件校驗，傳到父組件
    validateForm() {
      let flag = null;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          flag = true;
        } else {
          flag = false;
        }
      });
      return flag;
    },
    // 關閉註冊編號彈窗
    handleClose() {
      this.showRegistrationNoDialog = false;
    },
    // 車輛的註冊編號儲存
    registNoSave(data) {
      // this.form.vehicle.registrationNo = data.registrationNo;
      this.form.vehicle.identificationNo = data.identificationNo;

      const registrationNo = data.registrationNo;
      // const identificationNo = data.identificationNo;
      // console.log(new Array(registrationNo.replace(/(.{2})/g, "$1,")));

      // 為字符串每個length個字，添加一條橫線
      // const xreplace = (str, length) => {
      //   if (str.indexOf("-") != -1) {
      //     return str;
      //   }
      //   // str = str.replace(/-/g, "");
      //   var re = new RegExp("[a-zA-Z]{1,2}|[0-9]{1," + length + "}", "g");
      //   var ma = str.match(re);
      //   return ma.join("-");
      // };
      // const regAndIdNo = xreplace(registrationNo, 2);
      this.$set(this.form.vehicle, "regAndIdNo", registrationNo);
      this.$set(this.form.vehicle, "registrationNo", registrationNo);
      this.showRegistrationNoDialog = false;
    },
    // 驗證車身註冊編號弹窗
    onRegistNoFocus() {
      this.$refs["registrationNo"].blur();
      this.showRegistrationNoDialog = true;
    },
  },
  created() {
    // 根據申請類型設定驗證規則
    if (this.applicationType == "RENEW") {
      this.vehicleRules.regAndIdNo = [];
    }
  },
};
</script>

<style lang="scss" scoped>
.input-with-select {
  /deep/.el-input-group__prepend {
    width: auto;
    padding: 0;
  }
  /deep/.el-input-group__prepend .el-select {
    margin: -12px 0px;
  }
  /deep/.el-form-item.is-error .el-input-group__prepend .el-input__inner {
    border-color: transparent !important;
  }
}
.identificationNo_tips {
  color: #38959d;
  margin-bottom: 12px;
  line-height: 25px;
}
.identificationNo_mark {
  color: #38959d;
  margin: 12px 0;
  line-height: 25px;
}
/deep/.el-divider--horizontal {
  margin: 10px 0;
  .el-divider__text {
    color: #c0c4cc;
  }
}
</style>
<style>
.m-tooltip-popper {
  max-width: 500px;
  width: 80%;
  font-size: 18px;
}
</style>
